import { AbstractGenerateWorkplaceEntitiesStep } from './abstract-generate-workplace-entities-step';

export class GenerateWorkplaceMedicalExaminationStep extends AbstractGenerateWorkplaceEntitiesStep {

}
